import React from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "../translations/i18n";

export const I18nProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};


// function LanguageSwitcher() {
//   const { i18n } = useTranslation();

//   const changeLanguage = (lng: string) => {
//     i18n.changeLanguage(lng);
//   };

//   return (
//     <div>
//       <button onClick={() => changeLanguage("en")}>English</button>
//       <button onClick={() => changeLanguage("es")}>Español</button>
//     </div>
//   );
// }


// function WelcomeBanner() {
//   const { t } = useTranslation();
//   return <h1>{t("welcome")}</h1>;
// }